import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import '../../styles/landing.css';
import LandingNavbar from '../home/LandingNavbar';
import LandingFooter from '../home/LandingFooter';

const LandingLayout = () => (
  <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', bgcolor: '#fff' }}>
    <LandingNavbar />
    <Box component="main" sx={{ flex: 1 }}>
      <Outlet />
    </Box>
    <LandingFooter />
  </Box>
);

export default LandingLayout;
